import React from 'react'
import Icon from 'react-icon-base'

export default props => {
  return (
    <Icon viewBox="0 0 12 19" {...props}>
      <title>{props.title || 'Carousel-Arrow-Left'}</title>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.9142 18.4142C10.1332 19.1953 8.86683 19.1953 8.08579 18.4142L0.585788 10.9142C-0.195261 10.1332 -0.195261 8.86683 0.585788 8.08579L8.08579 0.585787C8.86684 -0.195263 10.1332 -0.195263 10.9142 0.585787C11.6953 1.36683 11.6953 2.63316 10.9142 3.41421L4.82843 9.5L10.9142 15.5858C11.6953 16.3668 11.6953 17.6332 10.9142 18.4142Z"
        fill="white"
      />
    </Icon>
  )
}
